import { useContext, useCallback, useEffect, useRef, createContext, useState,
  useMemo
} from 'react';

import { MouseAvailabilityContext } from './MouseFocusProvider';


export const DragInterfaceContext = createContext({});
export const DragGeometryContext = createContext({});

export default function MouseDragProvider({children}){


  const { requestMouseFocus,releaseMouseFocus, isMouseAvailable } = useContext(MouseAvailabilityContext);

  const [dragGeometry,setDragGeometry] = useState({});

  const dragInfo = useRef();
  const dragFocusRef = useRef();

  //what is being dragged?
  //I'm not sure how much we need to specify...
  //
  //what is the ID of the item that's being dragged

  const startDrag = useCallback(({event,onDragEnd,onMouseMove,mouseFocusControllerId,...info }) => {


    let p = [event.clientX,event.clientY];
    if( isMouseAvailable() && !dragInfo.current ){


      let result = requestMouseFocus("dragProvider");
      dragInfo.current = {
        start:p,
        ...info,
        onDragEnd,
        onMouseMove,
      }
      return true;
    }
    return false;
  },[])





  

  const canStartNewDrag = useCallback(() => {
    return !!dragFocusRef.current && isMouseAvailable();
  },[])


  const getDragInfo = useCallback(() => {
    //if we pass a function through here it will definitely
    //cause an issue.
    return (
      dragInfo.current 
    )
      //&& JSON.parse(JSON.stringify(dragInfo.current))
  },[])

  const getDragFocus = useCallback(() => {
    return (
      dragFocusRef.current 
      && 
      JSON.parse(JSON.stringify(dragFocusRef.current))
    )
  },[])

  useEffect(() => {

    function mouseUp(e){


      
      //e.preventDefault();

      if( dragInfo.current ){

        let start = dragInfo.current.start;
        let end = [e.clientX, e.clientY];
        let onDragEnd = dragInfo.current.onDragEnd;
        onDragEnd && onDragEnd(start,end,dragInfo.current,e);
      }
      dragInfo.current = null;
      setDragGeometry();
    }

    function mouseMove(e){
      if( dragInfo.current ){
        let info = dragInfo.current;
        let func = info?.onMouseMove;
        let end = [e.clientX, e.clientY];
        setDragGeometry({
          start:info.start,
          end,
          info
        })
        func && func(info.start, end, info)
      }

      
    }

    window.addEventListener('mouseup',mouseUp)
    window.addEventListener('mousemove',mouseMove)

    return () => {
      window.removeEventListener('mouseup',mouseUp);
      window.removeEventListener('mousemove',mouseMove);
    }

  },[])

  const dragInterface = useMemo(() => ({
    startDrag, 
    canStartNewDrag, 
    getDragFocus,
    getDragInfo,
  }),[])

  return (
    <DragInterfaceContext.Provider value={dragInterface}>
      <DragGeometryContext.Provider value={dragGeometry}>
        {children}
      </DragGeometryContext.Provider>
    </DragInterfaceContext.Provider>
  )

  
}


function deepFreeze(obj) {
  Object.freeze(obj);

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && typeof obj[key] === 'object') {
      deepFreeze(obj[key]);
    }
  }

  return obj;
}
